var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["../elements/combobox.html"] = require( "../elements/combobox.html" );
dependencies["../elements/fileIcon.html"] = require( "../elements/fileIcon.html" );
dependencies["./form.html"] = require( "./form.html" );




var shim = require("C:/Users/kaharmanny/source/repos/rentmagic.frontend/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["views/content/table.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("../elements/combobox.html", false, "views/content/table.html", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("combo", t_1);
output += "\r\n";
env.getTemplate("../elements/fileIcon.html", false, "views/content/table.html", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("fileIcon", t_4);
output += "\r\n";
env.getTemplate("./form.html", false, "views/content/table.html", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
context.setVariable("form", t_7);
output += "\r\n\r\n";
output += "\r\n\r\n";
var macro_t_10 = runtime.makeMacro(
["filter", "parent"], 
[], 
function (l_filter, l_parent, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("filter", l_filter);
frame.set("parent", l_parent);
var t_11 = "";t_11 += "\r\n\t";
frame = frame.push();
var t_14 = l_parent;
if(t_14) {var t_13 = t_14.length;
for(var t_12=0; t_12 < t_14.length; t_12++) {
var t_15 = t_14[t_12];
frame.set("branch", t_15);
frame.set("loop.index", t_12 + 1);
frame.set("loop.index0", t_12);
frame.set("loop.revindex", t_13 - t_12);
frame.set("loop.revindex0", t_13 - t_12 - 1);
frame.set("loop.first", t_12 === 0);
frame.set("loop.last", t_12 === t_13 - 1);
frame.set("loop.length", t_13);
t_11 += "\r\n\t\t";
if(runtime.memberLookup((t_15),"children")) {
t_11 += "\r\n\t\t\t<div class='branch collapsed'>\r\n\t\t\t\t<div class='branch-name'><span data-window-event=\"filterAction:";
t_11 += runtime.suppressValue(runtime.memberLookup((l_filter),"name"), env.opts.autoescape);
t_11 += ":";
t_11 += runtime.suppressValue(runtime.memberLookup((t_15),"Value"), env.opts.autoescape);
t_11 += "\">";
t_11 += runtime.suppressValue(runtime.memberLookup((t_15),"Text"), env.opts.autoescape);
t_11 += "</span></div>\r\n\t\t\t\t<div class=\"branches\">\r\n\t\t\t\t\t";
t_11 += runtime.suppressValue((lineno = 33, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "makeBranch"), "makeBranch", context, [l_filter,runtime.memberLookup((t_15),"children")])), env.opts.autoescape);
t_11 += "\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t";
;
}
else {
t_11 += "\r\n\t\t\t<div class=\"stick\" data-window-event=\"filterAction:";
t_11 += runtime.suppressValue(runtime.memberLookup((l_filter),"name"), env.opts.autoescape);
t_11 += ":";
t_11 += runtime.suppressValue(runtime.memberLookup((t_15),"Value"), env.opts.autoescape);
t_11 += "\"><span>";
t_11 += runtime.suppressValue(runtime.memberLookup((t_15),"Text"), env.opts.autoescape);
t_11 += "</span></div>\r\n\t\t";
;
}
t_11 += "\r\n\t";
;
}
}
frame = frame.pop();
t_11 += "\r\n";
;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
context.addExport("makeBranch");
context.setVariable("makeBranch", macro_t_10);
output += "\r\n\r\n";
output += "\r\n";
var macro_t_16 = runtime.makeMacro(
["cellStatus"], 
[], 
function (l_cellStatus, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("cellStatus", l_cellStatus);
var t_17 = "";t_17 += "\r\n\t<button class=\"btn btn-xs btn-status btn-disabled btn-";
t_17 += runtime.suppressValue(runtime.memberLookup((l_cellStatus),"Type"), env.opts.autoescape);
t_17 += "\" title=\"";
t_17 += runtime.suppressValue(runtime.memberLookup((l_cellStatus),"Description"), env.opts.autoescape);
t_17 += "\">&nbsp;</button>\r\n";
;
frame = frame.pop();
return new runtime.SafeString(t_17);
});
context.addExport("getCellStatus");
context.setVariable("getCellStatus", macro_t_16);
output += "\r\n\r\n";
var macro_t_18 = runtime.makeMacro(
["col", "columnindex", "index", "colval", "window", "cell", "allowEdit", "metadata"], 
[], 
function (l_col, l_columnindex, l_index, l_colval, l_window, l_cell, l_allowEdit, l_metadata, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("col", l_col);
frame.set("columnindex", l_columnindex);
frame.set("index", l_index);
frame.set("colval", l_colval);
frame.set("window", l_window);
frame.set("cell", l_cell);
frame.set("allowEdit", l_allowEdit);
frame.set("metadata", l_metadata);
var t_19 = "";if(runtime.memberLookup((runtime.memberLookup((l_metadata),runtime.memberLookup((l_col),"Name"))),"Status")) {
t_19 += "\r\n\t\t";
var t_20;
t_20 = (lineno = 49, colno = 34, runtime.callWrap(macro_t_16, "getCellStatus", context, [runtime.memberLookup((runtime.memberLookup((l_metadata),runtime.memberLookup((l_col),"Name"))),"Status")]));
frame.set("cellStatus", t_20, true);
if(frame.topLevel) {
context.setVariable("cellStatus", t_20);
}
if(frame.topLevel) {
context.addExport("cellStatus", t_20);
}
t_19 += "\r\n\t";
;
}
t_19 += "\r\n\r\n\t";
if(runtime.memberLookup((l_col),"Editor") == "link" && runtime.memberLookup((runtime.memberLookup((l_metadata),runtime.memberLookup((l_col),"Name"))),"Description")) {
t_19 += "\r\n\t<div class=\"case-0 table-cell field ";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\"\r\n\r\n\t\t\t";
if(runtime.memberLookup((l_col),"Width")) {
t_19 += " \r\n\t\t\t\tstyle=\"width: ";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Width"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t\t\r\n\t\t>\r\n\t\t";
if(l_colval) {
t_19 += "\r\n\t\t\t<a href=\"";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\" target=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Type"), env.opts.autoescape);
t_19 += "\">";
t_19 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_metadata),runtime.memberLookup((l_col),"Name"))),"Description"), env.opts.autoescape);
t_19 += "</a>\r\n\t\t";
;
}
t_19 += "\r\n\t</div>\r\n\r\n\r\n\t";
t_19 += "\r\n\t";
;
}
else {
if(runtime.memberLookup((l_col),"Name") == "ImageUrl") {
t_19 += "\r\n\t\t<div class=\"case-1 table-cell field ";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\">\r\n\t\t\t";
if(l_colval) {
t_19 += "\r\n\t\t\t\t<span img-url=\"";
t_19 += runtime.suppressValue(env.getFilter("safe").call(context, l_colval), env.opts.autoescape);
t_19 += "\" class=\"material-icons image\">&#xe3f4;</span>\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t\t";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "\r\n\t\t</div>\r\n\t";
t_19 += "\r\n\t";
;
}
else {
if((runtime.memberLookup((l_window),"bulkedit") || l_allowEdit) && runtime.memberLookup((l_col),"Type") == "Boolean") {
t_19 += "\r\n\t\t<div class=\"case-2 table-cell field checkbox";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?" " + runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\">\r\n\t\t\t<input name=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_19 += "[";
t_19 += runtime.suppressValue(l_columnindex, env.opts.autoescape);
t_19 += "]\"\ttype=\"checkbox\" title=\"";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\" ";
t_19 += runtime.suppressValue((l_colval?"checked":""), env.opts.autoescape);
t_19 += " ";
if(runtime.memberLookup((l_col),"BaseType") != runtime.memberLookup((l_col),"Type")) {
t_19 += " class=\"pull-left\"";
;
}
t_19 += ">\r\n\t\t\t";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "\r\n\t\t</div>\r\n\t";
t_19 += "\r\n\t";
;
}
else {
if(runtime.memberLookup((l_col),"Type") == "Boolean") {
t_19 += "\r\n\t\t<div class=\"case-3 table-cell field checkbox";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?" " + runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\">\r\n\t\t\t<input \"disabled\" type=\"checkbox\" title=\"";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\" ";
t_19 += runtime.suppressValue((l_colval?"checked":""), env.opts.autoescape);
t_19 += " ";
if(runtime.memberLookup((l_col),"BaseType") != runtime.memberLookup((l_col),"Type")) {
t_19 += " class=\"pull-left\"";
;
}
t_19 += ">\r\n\t\t\t";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "\r\n\t\t</div>";
;
}
else {
if((runtime.memberLookup((l_window),"bulkedit") || l_allowEdit) && (runtime.memberLookup((l_col),"Type") == "Date" || runtime.memberLookup((l_col),"Type") == "DateTime" || runtime.memberLookup((l_col),"Type") == "Time")) {
t_19 += "\r\n\t\t<div class=\"case-3 table-cell date-picker\"  data-replace=\"";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\" data-type=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Type"), env.opts.autoescape);
t_19 += "\">\r\n\t\t\t<span class=\"float-right\">";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "</span>\r\n\t\t\t<div class=\"field date editable-text ";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"Type") == "Money" || runtime.memberLookup((l_col),"Type") == "Decimal" || runtime.memberLookup((l_col),"Type") == "Int"?" number " + runtime.memberLookup((l_col),"Type"):""), env.opts.autoescape);
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?" " + runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t\tdata-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\" ";
t_19 += runtime.suppressValue((!runtime.memberLookup((l_col),"IsReadOnly")?"contenteditable=true":""), env.opts.autoescape);
t_19 += " name=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_19 += "[";
t_19 += runtime.suppressValue(l_columnindex, env.opts.autoescape);
t_19 += "]\">";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\r\n\t\t\t</div>\t\t\r\n\t\t</div>\r\n\t";
t_19 += "\r\n\t";
;
}
else {
if((runtime.memberLookup((l_window),"bulkedit") || l_allowEdit) && !(runtime.memberLookup((l_col),"IsRequired") && runtime.memberLookup((l_col),"IsPrimaryKey") && l_cell) && runtime.memberLookup((l_cell),"Combobox")) {
t_19 += "\r\n\t\t<div class=\"case-4 table-cell field";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?" " + runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
if(runtime.memberLookup((l_col),"Width")) {
t_19 += " \r\n\t\t\t\tstyle=\"min-width: ";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Width"), env.opts.autoescape);
t_19 += "; width: ";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Width"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t>\r\n\t\t\t\t";
if(runtime.memberLookup((l_col),"Name") == "DimensionID-3") {
t_19 += "\r\n\t\t\t\t";
t_19 += runtime.suppressValue((lineno = 101, colno = 39, runtime.callWrap(runtime.memberLookup((t_1),"constructTableRecordCombobox"), "combo[\"constructTableRecordCombobox\"]", context, [runtime.memberLookup((l_window),"session"),runtime.memberLookup((l_cell),"Combobox"),l_index,runtime.memberLookup((l_col),"Name") == "DimensionID-3"])), env.opts.autoescape);
t_19 += " ";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "\r\n\t\t\t";
;
}
else {
t_19 += "\r\n\t\t\t\t";
t_19 += runtime.suppressValue((lineno = 103, colno = 28, runtime.callWrap(runtime.memberLookup((t_1),"constructCombobox"), "combo[\"constructCombobox\"]", context, [runtime.memberLookup((l_window),"session"),runtime.memberLookup((l_cell),"Combobox"),runtime.memberLookup((l_col),"Width")])), env.opts.autoescape);
t_19 += " ";
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t</div>\r\n\t";
t_19 += "\r\n\t";
;
}
else {
if((runtime.memberLookup((l_window),"bulkedit") || l_allowEdit)) {
t_19 += "\r\n\t\t<div class=\"case-5 table-cell field\r\n\t\t\t";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"IsReadOnly") == false?" editable-text ":""), env.opts.autoescape);
t_19 += "\r\n\t\t\t";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"Type") == "Money" || runtime.memberLookup((l_col),"Type") == "Decimal" || runtime.memberLookup((l_col),"Type") == "Int"?" number " + runtime.memberLookup((l_col),"Type"):""), env.opts.autoescape);
t_19 += "\r\n\t\t\t";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?" " + runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
t_19 += "\r\n\t\t\t";
if(runtime.memberLookup((l_col),"IsReadOnly")) {
t_19 += "\r\n\t\t\t\tcontenteditable=\"false\"\r\n\t\t\t";
;
}
else {
t_19 += "\r\n\t\t\t\tcontenteditable=\"true\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t\tname=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Name"), env.opts.autoescape);
t_19 += "[";
t_19 += runtime.suppressValue(l_columnindex, env.opts.autoescape);
t_19 += "]\" \r\n\t\t\tdata-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\" \r\n\t\t\t";
if(runtime.memberLookup((l_col),"MinNumber")) {
t_19 += " \r\n\t\t\t\tmin=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"MinNumber"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t\t";
if(runtime.memberLookup((l_col),"MaxNumber")) {
t_19 += " \r\n\t\t\t\tmax=\"";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"MaxNumber"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t\t";
if(runtime.memberLookup((l_col),"Width")) {
t_19 += " \r\n\t\t\t\tstyle=\"width: ";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Width"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += "\r\n\t\t>\r\n\t\t\t";
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
t_19 += "\r\n\t\t</div>";
;
}
else {
t_19 += "\r\n\t\t<div class=\"case-6 table-cell field ";
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"Type") == "Money" || runtime.memberLookup((l_col),"Type") == "Decimal"?"number " + runtime.memberLookup((l_col),"Type"):""), env.opts.autoescape);
t_19 += runtime.suppressValue((runtime.memberLookup((l_col),"CustomClass")?runtime.memberLookup((l_col),"CustomClass"):""), env.opts.autoescape);
t_19 += "\" data-field-index=\"";
t_19 += runtime.suppressValue(l_index, env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
if(runtime.memberLookup((l_col),"Width")) {
t_19 += " \r\n\t\t\t\tstyle=\"min-width: ";
t_19 += runtime.suppressValue(runtime.memberLookup((l_col),"Width"), env.opts.autoescape);
t_19 += "\"\r\n\t\t\t";
;
}
t_19 += ">";
if(runtime.memberLookup((runtime.memberLookup((l_col),"Dropdown")),"Items")) {
t_19 += runtime.suppressValue((lineno = 137, colno = 54, runtime.callWrap(runtime.memberLookup((l_col),"getDropdownText"), "col[\"getDropdownText\"]", context, [l_colval])), env.opts.autoescape);
;
}
else {
if(l_cell && runtime.memberLookup((l_cell),"Initial")) {
t_19 += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((l_cell),"Initial")),"Description"), env.opts.autoescape);
;
}
else {
if(runtime.memberLookup((l_col),"Html")) {
t_19 += runtime.suppressValue(env.getFilter("safe").call(context, l_colval), env.opts.autoescape);
;
}
else {
t_19 += runtime.suppressValue(l_colval, env.opts.autoescape);
;
}
;
}
;
}
t_19 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "cellStatus"), env.opts.autoescape);
t_19 += "</div>";
;
}
;
}
;
}
;
}
;
}
;
}
;
}
;
frame = frame.pop();
return new runtime.SafeString(t_19);
});
context.addExport("setColumnCell");
context.setVariable("setColumnCell", macro_t_18);
output += "\r\n\r\n<div class=\"content\">\r\n\t<div class=\"table-view ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")?"unsortable":""), env.opts.autoescape);
output += "\">\r\n\t\t";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("header"))(env, context, frame, runtime, function(t_22,t_21) {
if(t_22) { cb(t_22); return; }
output += t_21;
output += "\r\n\r\n\t\t";
if((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Rows")),"length") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Columns")),"length")) {
output += "\r\n\t\t\t<form class=\"table-container\">\r\n\t\t\t\t<div class=\"table-index sticky-div\">\r\n\t\t\t\t\t<div class=\"table-row\">\r\n\t\t\t\t\t\t";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Options")),"DisableSelection")) {
output += "\r\n\t\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><div class=\"ellipsis\"><input type=\"checkbox\" title=\"Select all\"></div></label>\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_25 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Columns");
if(t_25) {var t_24 = t_25.length;
for(var t_23=0; t_23 < t_25.length; t_23++) {
var t_26 = t_25[t_23];
frame.set("col", t_26);
frame.set("loop.index", t_23 + 1);
frame.set("loop.index0", t_23);
frame.set("loop.revindex", t_24 - t_23);
frame.set("loop.revindex0", t_24 - t_23 - 1);
frame.set("loop.first", t_23 === 0);
frame.set("loop.last", t_23 === t_24 - 1);
frame.set("loop.length", t_24);
output += "\r\n\t\t\t\t\t\t\t<div class=\"table-cell ";
output += runtime.suppressValue((runtime.memberLookup((t_26),"Type") == "Money" || runtime.memberLookup((t_26),"Type") == "Decimal"?"number " + runtime.memberLookup((t_26),"Type"):""), env.opts.autoescape);
output += "\" data-window-event=\"toggle-column-sorting:";
output += runtime.suppressValue(runtime.memberLookup((t_26),"Name"), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((t_26),"Title"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t<div class=\"ellipsis\">";
if(runtime.memberLookup((t_26),"OrderType")) {
output += "<span class=\"material-icons\">";
output += runtime.suppressValue((runtime.memberLookup((t_26),"OrderType") == "DESC"?(env.getFilter("safe").call(context, "&#xe5c5;")):(env.getFilter("safe").call(context, "&#xe5c7;"))), env.opts.autoescape);
output += "</span>";
;
}
output += runtime.suppressValue(runtime.memberLookup((t_26),"Title"), env.opts.autoescape);
output += "</div>\r\n\t\t\t\t\t\t\t</div>";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\r\n\t\t\t\t<div class=\"table-body ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")?"bulkedit":""), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t<div class=\"table-rows\">\r\n\t\t\t\t\t";
var t_27;
t_27 = 0;
frame.set("rowIndex", t_27, true);
if(frame.topLevel) {
context.setVariable("rowIndex", t_27);
}
if(frame.topLevel) {
context.addExport("rowIndex", t_27);
}
output += "\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_30 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Rows");
if(t_30) {var t_29 = t_30.length;
for(var t_28=0; t_28 < t_30.length; t_28++) {
var t_31 = t_30[t_28];
frame.set("row", t_31);
frame.set("loop.index", t_28 + 1);
frame.set("loop.index0", t_28);
frame.set("loop.revindex", t_29 - t_28);
frame.set("loop.revindex0", t_29 - t_28 - 1);
frame.set("loop.first", t_28 === 0);
frame.set("loop.last", t_28 === t_29 - 1);
frame.set("loop.length", t_29);
output += "<div class=\"table-row\" data-row-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" style=\"";
output += runtime.suppressValue((lineno = 263, colno = 85, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"getCssInfo"), "window[\"getCssInfo\"]", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")])), env.opts.autoescape);
output += "\">";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Options")),"DisableSelection")) {
output += "<label class=\"table-cell checkbox selection-box\"><input type=\"checkbox\" data-commit-checkbox=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" title=\"Select\"></label>";
;
}
var t_32;
t_32 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("loopIndex", t_32, true);
if(frame.topLevel) {
context.setVariable("loopIndex", t_32);
}
if(frame.topLevel) {
context.addExport("loopIndex", t_32);
}
frame = frame.push();
var t_35 = t_31;
if(t_35) {var t_34 = t_35.length;
for(var t_33=0; t_33 < t_35.length; t_33++) {
var t_36 = t_35[t_33];
frame.set("col", t_36);
frame.set("loop.index", t_33 + 1);
frame.set("loop.index0", t_33);
frame.set("loop.revindex", t_34 - t_33);
frame.set("loop.revindex0", t_34 - t_33 - 1);
frame.set("loop.first", t_33 === 0);
frame.set("loop.last", t_33 === t_34 - 1);
frame.set("loop.length", t_34);
output += runtime.suppressValue((lineno = 271, colno = 22, runtime.callWrap(macro_t_18, "setColumnCell", context, [runtime.memberLookup((t_36),"Column"),runtime.contextOrFrameLookup(context, frame, "loopIndex"),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),runtime.memberLookup((t_36),"Value"),runtime.contextOrFrameLookup(context, frame, "window"),t_36,runtime.memberLookup((runtime.memberLookup((t_36),"Column")),"AllowEditOnTable"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Metadata")),runtime.contextOrFrameLookup(context, frame, "rowIndex"))])), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t</div>";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "\r\n\t\t\t\t\t\t\t<div class=\"table-row new-row\">\r\n\t\t\t\t\t\t\t\t<label class=\"table-cell checkbox selection-box\"><input type=\"checkbox\" data-commit-checkbox=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\" title=\"Select\"></label>\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_39 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Columns");
if(t_39) {var t_38 = t_39.length;
for(var t_37=0; t_37 < t_39.length; t_37++) {
var t_40 = t_39[t_37];
frame.set("col", t_40);
frame.set("loop.index", t_37 + 1);
frame.set("loop.index0", t_37);
frame.set("loop.revindex", t_38 - t_37);
frame.set("loop.revindex0", t_38 - t_37 - 1);
frame.set("loop.first", t_37 === 0);
frame.set("loop.last", t_37 === t_38 - 1);
frame.set("loop.length", t_38);
output += runtime.suppressValue((lineno = 280, colno = 23, runtime.callWrap(macro_t_18, "setColumnCell", context, [t_40,"",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"),"",runtime.contextOrFrameLookup(context, frame, "window"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.contextOrFrameLookup(context, frame, "null"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Metadata")),runtime.contextOrFrameLookup(context, frame, "rowIndex"))])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t</form>\r\n\t\t";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Table")),"Columns")),"length") == 0) {
output += "\r\n\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"NoColumnsFound"), env.opts.autoescape);
output += "</p>\r\n\t\t";
;
}
else {
output += "\r\n\t\t\t<p>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"NoRowsFound"), env.opts.autoescape);
output += "</p>\r\n\t\t";
;
}
;
}
output += "\r\n\r\n\t\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value") > 0) {
output += "<div class=\"table-footer clearfix sticky-div stick-to-bottom\">\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination") && !runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "<ul class=\"pagination\">\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"first") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"first")?"disabled":""), env.opts.autoescape);
output += ">&#xe045;</li>\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"prev") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"prev")?"disabled":""), env.opts.autoescape);
output += ">&#xe314;</li>\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_43 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"sequence");
if(t_43) {var t_42 = t_43.length;
for(var t_41=0; t_41 < t_43.length; t_41++) {
var t_44 = t_43[t_41];
frame.set("item", t_44);
frame.set("loop.index", t_41 + 1);
frame.set("loop.index0", t_41);
frame.set("loop.revindex", t_42 - t_41);
frame.set("loop.revindex0", t_42 - t_41 - 1);
frame.set("loop.first", t_41 === 0);
frame.set("loop.last", t_41 === t_42 - 1);
frame.set("loop.length", t_42);
output += "<li class=\"page ";
output += runtime.suppressValue((runtime.memberLookup((t_44),"current")?"current":""), env.opts.autoescape);
output += "\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((t_44),"page"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_44),"page"), env.opts.autoescape);
output += "</li>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"next") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"next")?"disabled":""), env.opts.autoescape);
output += ">&#xe315;</li>\r\n\t\t\t\t\t\t<li class=\"button button-menu material-icons\" data-window-event=\"page:";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"last") || "", env.opts.autoescape);
output += "\" ";
output += runtime.suppressValue((!runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"pagination")),"last")?"disabled":""), env.opts.autoescape);
output += ">&#xe044;</li>\r\n\t\t\t\t\t</ul>\r\n\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals")),"length") > 0) {
output += "\r\n\t\t\t\t\t<div class=\"pull-right\">\r\n\t\t\t\t\t";
frame = frame.push();
var t_47 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals");
if(t_47) {var t_46 = t_47.length;
for(var t_45=0; t_45 < t_47.length; t_45++) {
var t_48 = t_47[t_45];
frame.set("col", t_48);
frame.set("loop.index", t_45 + 1);
frame.set("loop.index0", t_45);
frame.set("loop.revindex", t_46 - t_45);
frame.set("loop.revindex0", t_46 - t_45 - 1);
frame.set("loop.first", t_45 === 0);
frame.set("loop.last", t_45 === t_46 - 1);
frame.set("loop.length", t_46);
output += "<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_48),"Title"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_48),"Value"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t</div>";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</div>\r\n\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\r\n\t\t\t\t<div class=\"fake-button button button-menu no-hover no-action\">\r\n\t\t\t\t\t";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Options")),"DisableSelection")) {
output += "\r\n\t\t\t\t\t\t<span data-select-count>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"selection")),"length"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t/\r\n\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\t\t";
;
}
output += "\r\n\t</div>\r\n</div>\r\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_header(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
output += "\r\n\t\t\t";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit")) {
output += "\r\n\t\t\t\t<div class=\"table-form sticky-div\">\r\n\t\t\t\t\t<select class=\"number-of\">\r\n\t\t\t\t\t\t";
frame = frame.push();
var t_51 = [15,20,50,100,200,500];
if(t_51) {var t_50 = t_51.length;
for(var t_49=0; t_49 < t_51.length; t_49++) {
var t_52 = t_51[t_49];
frame.set("i", t_52);
frame.set("loop.index", t_49 + 1);
frame.set("loop.index0", t_49);
frame.set("loop.revindex", t_50 - t_49);
frame.set("loop.revindex0", t_50 - t_49 - 1);
frame.set("loop.first", t_49 === 0);
frame.set("loop.last", t_49 === t_50 - 1);
frame.set("loop.length", t_50);
output += "\r\n\t\t\t\t\t\t\t<option ";
output += runtime.suppressValue((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Request")),"Data")),"PageSize") == t_52?"selected":""), env.opts.autoescape);
output += ">";
output += runtime.suppressValue(t_52, env.opts.autoescape);
output += "</option>\r\n\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t</select>\r\n\r\n\t\t\t\t\t<form class=\"search-bar\">\r\n\t\t\t\t\t\t<div class=\"search-box\">\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"filters")),"usedate")) {
output += "\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_55 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"filters")),"date");
if(t_55) {var t_54 = t_55.length;
for(var t_53=0; t_53 < t_55.length; t_53++) {
var t_56 = t_55[t_53];
frame.set("filter", t_56);
frame.set("loop.index", t_53 + 1);
frame.set("loop.index0", t_53);
frame.set("loop.revindex", t_54 - t_53);
frame.set("loop.revindex0", t_54 - t_53 - 1);
frame.set("loop.first", t_53 === 0);
frame.set("loop.last", t_53 === t_54 - 1);
frame.set("loop.length", t_54);
if(runtime.memberLookup((t_56),"value")) {
output += "<span class=\"filter\" data-window-event=\"remove-date-query:";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((t_56),"text"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_56),"value"), env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t\t";
;
}
else {
output += "<div class=\"dropdown filter-option date-picker\" data-type=\"Date\" data-replace>\r\n\t\t\t\t\t\t\t\t\t\t\t<button class=\"toggle-menu button button-menu\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<span>";
output += runtime.suppressValue(runtime.memberLookup((t_56),"text"), env.opts.autoescape);
output += "</span> \r\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"material-icons\" style=\"font-size:inherit;\">&#xe5c5;</span>\r\n\t\t\t\t\t\t\t\t\t\t\t</button>\r\n\t\t\t\t\t\t\t\t\t\t\t<input type=\"hidden\" class=\"date\" data-index=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t</div>";
;
}
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Filters")) {
output += "\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_59 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Filters");
if(t_59) {var t_58 = t_59.length;
for(var t_57=0; t_57 < t_59.length; t_57++) {
var t_60 = t_59[t_57];
frame.set("filter", t_60);
frame.set("loop.index", t_57 + 1);
frame.set("loop.index0", t_57);
frame.set("loop.revindex", t_58 - t_57);
frame.set("loop.revindex0", t_58 - t_57 - 1);
frame.set("loop.first", t_57 === 0);
frame.set("loop.last", t_57 === t_58 - 1);
frame.set("loop.length", t_58);
if(runtime.memberLookup((t_60),"Type") == "List") {
output += "\r\n\t\t\t\t\t\t\t\t\t<div class=\"filter-option right\">\r\n\t\t\t\t\t\t\t\t\t\t<select data-filter-target=\"";
output += runtime.suppressValue(runtime.memberLookup((t_60),"Target"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((t_60),"Options")),"length") > 0) {
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t\t<option disabled ";
output += runtime.suppressValue((runtime.memberLookup((t_60),"Selected") < 0?"selected":""), env.opts.autoescape);
output += " value=\"\">Filter</option>\r\n\t\t\t\t\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_63 = runtime.memberLookup((t_60),"Options");
if(t_63) {var t_62 = t_63.length;
for(var t_61=0; t_61 < t_63.length; t_61++) {
var t_64 = t_63[t_61];
frame.set("item", t_64);
frame.set("loop.index", t_61 + 1);
frame.set("loop.index0", t_61);
frame.set("loop.revindex", t_62 - t_61);
frame.set("loop.revindex0", t_62 - t_61 - 1);
frame.set("loop.first", t_61 === 0);
frame.set("loop.last", t_61 === t_62 - 1);
frame.set("loop.length", t_62);
output += "\r\n\t\t\t\t\t\t\t\t\t\t\t<option ";
output += runtime.suppressValue((runtime.memberLookup((t_60),"Selected") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0")?"selected":""), env.opts.autoescape);
output += " value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0"), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_64),"Key"), env.opts.autoescape);
output += "</option>\r\n\t\t\t\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t\t\t</select>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t";
;
}
if(runtime.memberLookup((t_60),"Type") == "Treeview") {
output += "\r\n\t\t\t\t\t\t\t\t\t<div class=\"dropdown right filter-option\">\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"button button-menu fake-button toggle-menu\">\r\n\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue(runtime.memberLookup((t_60),"text"), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"menu hide tree-view white\">\r\n\t\t\t\t\t\t\t\t\t\t\t";
output += runtime.suppressValue((lineno = 193, colno = 22, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "makeBranch"), "makeBranch", context, [t_60,runtime.memberLookup((t_60),"list")])), env.opts.autoescape);
output += "\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t";
;
}
;
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\r\n\t\t\t\t\t\t\t";
if(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data")),"Search") && runtime.memberLookup(((lineno = 200, colno = 85, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"getSearchColumns"), "window[\"getSearchColumns\"]", context, []))),"length") > 0) {
output += "\r\n\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_67 = runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Request")),"Data")),"Search");
if(t_67) {var t_66 = t_67.length;
for(var t_65=0; t_65 < t_67.length; t_65++) {
var t_68 = t_67[t_65];
frame.set("searchObj", t_68);
frame.set("loop.index", t_65 + 1);
frame.set("loop.index0", t_65);
frame.set("loop.revindex", t_66 - t_65);
frame.set("loop.revindex0", t_66 - t_65 - 1);
frame.set("loop.first", t_65 === 0);
frame.set("loop.last", t_65 === t_66 - 1);
frame.set("loop.length", t_66);
output += "\r\n\t\t\t\t\t\t\t\t\t";
var t_69;
t_69 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"index0");
frame.set("offset", t_69, true);
if(frame.topLevel) {
context.setVariable("offset", t_69);
}
if(frame.topLevel) {
context.addExport("offset", t_69);
}
output += "\r\n\t\t\t\t\t\t\t\t\t";
frame = frame.push();
var t_72 = t_68;
if(t_72) {var t_70;
if(runtime.isArray(t_72)) {
var t_71 = t_72.length;
for(t_70=0; t_70 < t_72.length; t_70++) {
var t_73 = t_72[t_70][0]
frame.set("columnSelection", t_72[t_70][0]);
var t_74 = t_72[t_70][1]
frame.set("searchTerm", t_72[t_70][1]);
frame.set("loop.index", t_70 + 1);
frame.set("loop.index0", t_70);
frame.set("loop.revindex", t_71 - t_70);
frame.set("loop.revindex0", t_71 - t_70 - 1);
frame.set("loop.first", t_70 === 0);
frame.set("loop.last", t_70 === t_71 - 1);
frame.set("loop.length", t_71);
output += "\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"filter\" data-window-event=\"remove-text-query:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "offset"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span>";
output += runtime.suppressValue(t_74, env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t";
;
}
} else {
t_70 = -1;
var t_71 = runtime.keys(t_72).length;
for(var t_75 in t_72) {
t_70++;
var t_76 = t_72[t_75];
frame.set("columnSelection", t_75);
frame.set("searchTerm", t_76);
frame.set("loop.index", t_70 + 1);
frame.set("loop.index0", t_70);
frame.set("loop.revindex", t_71 - t_70);
frame.set("loop.revindex0", t_71 - t_70 - 1);
frame.set("loop.first", t_70 === 0);
frame.set("loop.last", t_70 === t_71 - 1);
frame.set("loop.length", t_71);
output += "\r\n\t\t\t\t\t\t\t\t\t\t<div class=\"filter\" data-window-event=\"remove-text-query:";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "offset"), env.opts.autoescape);
output += "\">\r\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"close material-icons\" style=\"font-size:inherit;\">&#xe5cd;</span>\r\n\t\t\t\t\t\t\t\t\t\t\t<span>";
output += runtime.suppressValue(t_76, env.opts.autoescape);
output += "</span>\r\n\t\t\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t\t";
;
}
}
}
frame = frame.pop();
output += "\r\n\t\t\t\t\t\t\t\t";
;
}
}
frame = frame.pop();
output += "\r\n\r\n\t\t\t\t\t\t\t\t<div class=\"search-input-container\">\r\n\t\t\t\t\t\t\t\t\t<input class=\"input ignore-next ignore-reset\" placeholder=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"session")),"translations")),"PlaceholderSearch"), env.opts.autoescape);
output += "\" >\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t";
;
}
output += "\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</form>\r\n\r\n                    ";
if(!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"bulkedit") && runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value") > 0) {
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals")),"length") > 0) {
output += "\r\n                        <div class=\"pull-right\">\r\n                            ";
frame = frame.push();
var t_79 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Totals");
if(t_79) {var t_78 = t_79.length;
for(var t_77=0; t_77 < t_79.length; t_77++) {
var t_80 = t_79[t_77];
frame.set("col", t_80);
frame.set("loop.index", t_77 + 1);
frame.set("loop.index0", t_77);
frame.set("loop.revindex", t_78 - t_77);
frame.set("loop.revindex0", t_78 - t_77 - 1);
frame.set("loop.first", t_77 === 0);
frame.set("loop.last", t_77 === t_78 - 1);
frame.set("loop.length", t_78);
output += "<div class=\"fake-button button button-menu no-hover no-action\" style=\"margin-bottom: 4px;\">\r\n                                ";
output += runtime.suppressValue(runtime.memberLookup((t_80),"Title"), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue(runtime.memberLookup((t_80),"Value"), env.opts.autoescape);
output += "\r\n                            </div>";
;
}
}
frame = frame.pop();
output += "\r\n                        </div>\r\n                        ";
;
}
output += "\r\n\r\n                        <div class=\"fake-button button button-menu no-hover no-action\" style=\"margin-bottom: 4px;\">\r\n                            ";
if(!runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"output")),"Options")),"DisableSelection")) {
output += "\r\n                            <span data-select-count>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "window")),"selection")),"length"), env.opts.autoescape);
output += "</span>\r\n                            /\r\n                            ";
;
}
output += "\r\n                            <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "data")),"Data")),"Totals")),"RowCount")),"Value"), env.opts.autoescape);
output += "</span>\r\n                        </div>\r\n\r\n                    ";
;
}
output += "\r\n\r\n\t\t\t\t</div>\r\n\t\t\t";
;
}
output += "\r\n\t\t";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_header: b_header,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["views/content/table.html"] , dependencies)